<template>
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
            fill="#F0F0F0"
        />
        <path
            d="M21.378 15.4785C21.78 14.3951 22 13.2234 22 12.0002C22 10.777 21.78 9.60529 21.378 8.52197H2.62199C2.22004 9.60529 2 10.777 2 12.0002C2 13.2234 2.22004 14.3951 2.62199 15.4785L12 16.348L21.378 15.4785Z"
            fill="#0052B4"
        />
        <path
            d="M11.9991 21.9998C16.2987 21.9998 19.9642 19.286 21.3771 15.478H2.62109C4.03402 19.286 7.69945 21.9998 11.9991 21.9998Z"
            fill="#D80027"
        />
    </svg>
</template>
